import { DB, ref, firebaseAuth } from '../config/firebaseConfig'
import { collection, query, where, orderBy, getDocs } from "firebase/firestore"


export const updateCart = ({ commit }, { item, price, discount, quantity, isAdd }) => {
	commit('UPDATE_CART', { item, price, discount, quantity, isAdd })
	if (isAdd) {
		commit('ADD_MESSAGE', { message: "Added to cart: " + item.title, messageClass: "success", autoClose: true })
	}
}

export const removeItemInCart = ({ commit }, { item }) => {
	commit('REMOVE_CART_ITEM', { item });
}

export const authStatusChange = ({ commit }) => {
	commit('AUTH_STATUS_CHANGE');
}

export function loginWithGoogle(_, { credential }) {
	return firebaseAuth().signInWithCredential(credential)
}

export const logout = ({ commit }) => {
	commit('SET_CART', []); // clear current cart

	firebaseAuth.signOut().then(() => {
		commit('AUTH_STATUS_CHANGE')
	}
	)
}

/*
export const registerByEmail = (_, {email, password}) => {
	return firebaseAuth().createUserWithEmailAndPassword(email, password);
}

export function loginWithEmail (_, {email, password}) {
	return firebaseAuth().signInWithEmailAndPassword(email, password);
}
*/

export async function listenToProductList({ commit }, { orgId, location }) {
	commit('UPDATE_ORG_ID', orgId)
	if (orgId == "1")
		commit('UPDATE_ORG_NAME', 'Ketco')
	else
		commit('UPDATE_ORG_NAME', orgId)
	commit('UPDATE_LOCATION', location)

	const q = query(collection(DB, "Org", orgId, "Item1"), where("retailSale", "==", true), orderBy("order"))
	var items = []
	var i = 0

	const querySnapshot = await getDocs(q)
	querySnapshot.forEach((doc) => {
		// doc.data() is never undefined for query doc snapshots
		//console.log(doc.id, " => ", doc.data())
		items[i] = doc.data()
		i = i + 1
	})
	// Sort by order
	commit('UPDATE_ITEM1_LIST', items)
	// Update Auth Status
	commit('AUTH_STATUS_CHANGE')

}

/* export function listenToProductList1({commit}, {orgId, location}) {
	commit('UPDATE_ORG_ID', orgId)
	commit('UPDATE_LOCATION', location)
	return ref.child(orgId).on('value', (orgInfo) => {

		commit('UPDATE_ITEM1_LIST', orgInfo.val().items)
		commit('UPDATE_ORG_NAME', orgInfo.val().name)
	});
} */

/*
export function listenToProductList_Old({commit}, {orgId, location}) {
	//var orgId = new URL(location.href).searchParams.get('org')
	commit('UPDATE_ORG_ID', orgId)
	commit('UPDATE_LOCATION', location)
	var formData = new FormData()
	formData.append('orgId', orgId)

	axios({
		method: 'POST',
		baseURL: process.env.VUE_APP_ROOT_API,
		url: '/GetItem1sRetailStore/',
		data: formData,
		headers: {
			'Authorization': 'Bearer ',
			'OrgId': '',
			'Content-Type': 'multipart/form-data',
		},
	})
	.then(function (response) {
		if (response.data.err != ''){
			commit('ADD_MESSAGE', {messageClass: "warning", message: response.data.err})
		}
		else {
			commit('UPDATE_ITEM1_LIST', response.data.item1List)
			commit('UPDATE_ORG_NAME', response.data.orgName)
		}
	})
	.catch(function (error) {
		commit('ADD_MESSAGE', {messageClass: "danger", message: String(error)})
	})
}
*/

export function getItem2List({ commit }, { item1Name }) {
	commit('UPDATE_ITEM2_LIST', item1Name)
	commit('UPDATE_SHOW_ITEM_LEVEL', 2)
}

export function getShoppingCart({ commit }, { uid, currentCart }) {
	if (uid) {
		return ref.child("cart/" + uid).once('value').then((cart) => {
			// console.log(cart.val());
			if (cart.val() && (!currentCart || currentCart.length == 0)) {
				commit('SET_CART', cart.val());
			}
		});
	} else {
		// console.log("User has not logged in");
	}
}

export function saveShoppingCart(_, { uid, cartItemList }) {
	// console.log("ACTIONS saveShoppingCart");
	// console.log("CART DATA", cartItemList);
	return ref.child("cart/" + uid).set(cartItemList);
}

export function saveToTransaction(_, { uid, cartItemList }) {
	let newTransactionKey = ref.child("transactions").push().key;
	var newTransaction = {}
	newTransaction['/transactions/' + uid + '/' + newTransactionKey] = cartItemList;
	return ref.update(newTransaction);
}
